<template>
  <form v-on:submit.stop.prevent="solicitarRemocao" class="c-atendimento" :class="{'open': opened}">
    <a class="btn c-a-close" @click="$emit('close')"><i class="fa fa-times"/></a>
    <div class="c-a-body">

      <a v-if="!atendimento.iniciado" class="w-full btn btn-danger"
         @click="iniciarAtendimento"
      >
        <i class="fa fa-phone-volume"/>
        <span v-if="!loading" class="m-l">Receber ligação e iniciar atendimento</span>
        <span v-else>
          Iniciando atendimento...
        </span>
      </a>
      <div class="alert bg-black text-white text-center" v-else>
        Atendimento inciado em {{ atendimento.data.date|formatDate('DD/MM/YYYY HH:mm') }} com o protocolo #{{
        atendimento.id }}
      </div>

      <div class="m-t">Agente</div>
        <v-select :disabled="!atendimento.iniciado" :options="agentesComputed" placeholder="Selecione um Agente" v-model="atendimento.selAgente"></v-select>
      <div class="m-t">Classificação</div> <!-- categoriaError -->
        <select class="form-control" required :disabled="!atendimento.iniciado"
                v-model="atendimento.categoria"
        >
          <option :value="null">Selecione a classificação</option>
          <option v-for="cat in categoriaComputed" :value="cat.value">{{cat.label}}</option>
        </select>
      <div class="row">
        <div class="col-md-6" v-if="!atendimento.semPlaca && !atendimento.firstPlaca">
          <div class="m-t">Placa</div>
          <input class="input-sm form-control" ref="placa" :required="!atendimento.semPlaca && !atendimento.firstPlaca" v-model="atendimento.placa"
                :disabled="!atendimento.iniciado"/>
        </div>
         <div class="col-sm-6" v-else>
          <div class="m-t chassi">Chassi</div>
          <input class="input-sm form-control" ref="chassi" v-model="atendimento.chassi"
                :disabled="!atendimento.iniciado"/>
        </div>
        <div class="col-sm-3">
          <div class="m-t semplaca">Sem placa</div>
          <input type="checkbox" class="form-control" name="semplaca" ref="semPlaca" v-model="atendimento.semPlaca"
                :disabled="!atendimento.iniciado">
        </div>
         <div class="col-sm-3">
          <div class="m-t first-placa"> 1º Emplacamento</div>
          <input type="checkbox" class="form-control" name="semplaca" ref="firstPlaca" v-model="atendimento.firstPlaca"
                :disabled="!atendimento.iniciado">
        </div>
      </div>
        <div class="m-t">Modelo/Nome Veiculo</div>
      <input class="input-sm form-control" ref="nomeVeiculo" v-model="atendimento.nomeVeiculo"
             :disabled="!atendimento.iniciado"/>

      <div class="m-t">Recolher em</div>
      <input class="input-sm form-control" required ref="enderecoRecolhimento"
             v-model="atendimento.enderecoRecolhimento"
             :disabled="!atendimento.iniciado"/>
      <div @click="geocodeAddress" :class="{'disabled': !atendimento.iniciado}"
           class="btn btn-xs bg-black text-white m-t-xs">
        <i class="fa fa-map-marker-alt"></i> Buscar no mapa
      </div>

      <div class="m-t">Entregar em</div>
      <select class="form-control" :disabled="!atendimento.iniciado"
              v-model="atendimento.patioDestino"
      >
        <option :value="null">Selecione o pátio</option>
        <option v-for="cat in patiosComputed" :value="cat.value">{{cat.label}}</option>
      </select>
      <div class="m-t">Reboquista</div>
      <!--<u-search inverted v-model="atendimento.reboquistaNome" placeholder="Selecione um reboquista"
                :disable="!atendimento.iniciado">
        <u-autocomplete @search="buscaReboquista" @selected="selectedReboquista"/>
      </u-search>
-->
      <select class="form-control" :disabled="!atendimento.iniciado"
              v-model="atendimento.reboquista"
      >
        <option :value="null">Selecione o reboquista</option>
        <option v-for="reboque in reboques" :value="reboque.id">{{reboque.label}}</option>
      </select>

      <div class="m-t-xl">
        <textarea class="form-control" rows="4" v-model="atendimento.observacoes" :disabled="!atendimento.iniciado"
                  placeholder="Se tiver alguma observação, digite aqui" style="max-height: 50px"/>
      </div>

      <div class="m-t">
        <button type="submit" class="btn btn-success btn-solicitar" :disabled="!atendimento.iniciado">
          Solicitar Remoção <!--<small class="m-l text-lowercase">ou pressione ctrl + enter</small>-->
        </button>
      </div>

    </div>
  </form>
</template>

<script>
  import {iniciarAtendimento, solicitarRemocao, getReboques} from '../../../domain/callcenter/services'
  import printError from '../../../utils/printError'
  /* let reboquistas = [
    {
      id: 7,
      label: 'Sidnei Miranda',
      sublabel: 'Placa MTA3H06',
      value: 'Sidnei Miranda'
    }
  ] */
  let templateAtendimento = {
    iniciado: false,
    id: null,
    data: null,
    categoria: null,
    nomeAgente: null,
    agente: null,
    selAgente: null,
    placa: null,
    chassi: null,
    semPlaca: false,
    firstPlaca: false,
    nomeVeiculo: null,
    enderecoRecolhimento: null,
    latRecolhimento: null,
    lngRecolhimento: null,
    enderecoEntrega: null,
    patioDestino: null,
    patioDestinoNome: null,
    observacoes: null,
    reboquistaNome: null,
    reboquista: null
  }
  export default {
    name: 'Atendimento',
    components: {},
    props: ['opened', 'patios', 'categoria', 'agentes'],
    data () {
      return {
        loading: false,
        loadingSolicitacao: false,
        atendimento: JSON.parse(JSON.stringify(templateAtendimento)),
        categoriaError: false,
        cachePlaca: null,
        reboques: [],
        categorias: [],
        categoriasTranslate: ['Pequeno Porte', 'Médio Porte', 'Grande Porte']
      }
    },
    computed: {
      categoriaComputed () {
        let categoria = this.categoria.splice(2, 1)
        console.log(categoria)
        return this.categoria.map((v, i) => {
          return { label: this.categoriasTranslate[i] || v.nome, value: v.id }
        })
      },
      patiosComputed () {
        return this.patios.map((v) => {
          return {label: v.nome, value: v.id}
        })
      },
      agentesComputed () {
        return this.agentes.map((v) => {
          return {label: v.nome, value: v.id}
        })
      }
    },
    created () {
    },
    mounted () {
      if (this.$route.query.redirect && this.$route.query.redirect === 558) {
        this.iniciarAtendimento()
        let data = this.$route.query
        this.atendimento = data
        // this.atendimento.categoria = data.categoria.id
        // this.atendimento.enderecoRecolhimento = data.enderecoRecolhimento
        // this.atendimento.patioDestino = data.patioDestino.id
        // this.atendimento.observacoes = data.observacoes
        console.log('solicitacao', data)
      } else {
        console.log('não redirecionado')
      }
      this.getReboques()
      console.log(this.agentes)
    },
    methods: {
      iniciarAtendimento () {
        this.loading = true
        console.log('patio', this.patio)
        iniciarAtendimento(this.atendimento)
          .then(({data}) => {
            console.log(data)
            this.loading = false
            this.atendimento.iniciado = true
            this.atendimento.id = data.id
            this.atendimento.data = data.dataInicio
            // if (this.patios.length === 1) {
            //   this.atendimento.patioDestino = this.patios[0].id
            //   this.atendimento.patioDestinoNome = this.patios[0].nome
            // }
            this.$emit('novoAtendimento', data)
          })
          .catch(({response}) => {
            this.loading = false
            // this.$uloc.notify({color: 'negative', message: `Erro ao tentar registrar o atendimento "${response.data}"`})
            alert(`Erro ao tentar registrar o atendimento "${response.data}"`)
          })
      },
      buscaReboquista (terms, done) {
        /* setTimeout(() => {
          done(filter(terms, {field: 'label', list: reboquistas}))
        }, 200) */
      },
      getReboques () {
        getReboques()
          .then(({data}) => {
            console.log(data)
            let reboques = data.map(r => {
              return {
                id: r.id,
                label: r.nome,
                sublabel: r.descricao,
                value: r.nome
              }
            })
            this.reboques = reboques
            console.log(reboques)
            // done(filter(terms, {field: 'label', list: reboques}))
          })
          .catch(({response}) => {
            alert(`Erro ao tentar carregar os reboques disponíveis "${printError(response)}"`)
          })
      },
      selectedReboquista (item) {
        // this.$uloc.notify(`Selecionado "${item.value}"`)
        this.atendimento.agente = this.atendimento.selAgente.value
      },
      solicitarRemocao () {
        this.atendimento.reboquista = this.atendimento.reboquista.id
        this.atendimento.agente = this.atendimento.selAgente.value
        this.loadingSolicitacao = true
        this.categoriaError = false

        if (this.atendimento.categoria === null) {
          /* this.$uloc.notify({
            color: 'negative',
            message: `Você precisa selecionar a categoria da remocão antes de solicitá-la`
          }) */
          alert(`Você precisa selecionar a categoria da remocão antes de solicitá-la`)
          this.categoriaError = true
          return
        }

        let callback = () => {
          solicitarRemocao(this.atendimento.id, this.atendimento)
            .then((response) => {
              let data = response.data
              console.log(data)
              this.loading = false
              this.atendimento.iniciado = true
              this.atendimento.id = data.id
              this.atendimento.data = data.dataInicio
              this.$emit('atualizaAtendimento', data)
              /* this.$uloc.notify({
                color: 'positive',
                message: `Remoção solicitada com sucesso! Tempo limite: ${response.data.categoria.prazoMaximo} minutos`
              }) */
              alert(`Remoção solicitada com sucesso! Tempo limite: ${response.data.categoria.prazoMaximo} minutos`)
              this.close()
              window.setTimeout(() => {
                this.reset()
              }, 1000)
            })
            .catch((response) => {
              this.loading = false
              /* this.$uloc.notify({
                color: 'negative',
                message: `Erro ao tentar registrar a solicitação de remoção "${printError(response)}"`
              }) */
              alert(`Erro ao tentar registrar a solicitação de remoção "${printError(response)}"`)
            })
        }

        if (this.$parent.$remocaoMarker) {
          let latLng = this.$parent.$remocaoMarker.position.toJSON()
          console.log(latLng)
          this.atendimento.latRecolhimento = String(latLng.lat)
          this.atendimento.lngRecolhimento = String(latLng.lng)
          callback()
        } else {
          console.log('Não existe localização $remocaoMarker')
          /* this.$uloc.dialog({
            title: 'Localização no mapa não definida!',
            message: 'Você está tentando registrar uma solicitação sem encontrar a posição geográfica no mapa.',
            ok: 'Ok, registrar mesmo assim',
            cancel: 'Voltar e definir posição'
          }).then(() => {
            callback()
          }).catch(() => {
            this.$uloc.notify('Digite um endereço e clique em Buscar no Mapa...')
          }) */
          if (!window.confirm('Localização no mapa não definida! Você está tentando registrar uma solicitação sem encontrar a posição geográfica no mapa. Registrar mesmo assim ?')) {
            return
          }
          callback()
        }
      },
      close () {
        this.$emit('close')
      },
      changePatioDestino () {
        let patio = this.patiosComputed.filter(v => v.value === this.atendimento.patioDestino)
        if (Array.isArray(patio) && patio.length > 0) {
          patio = patio[0]
        }
        this.atendimento.patioDestinoNome = patio.label
      },
      reset () {
        this.atendimento = JSON.parse(JSON.stringify(templateAtendimento))
      },

      geocodeAddress () {
        this.$emit('geocodeAddress', this.atendimento.enderecoRecolhimento)
      }
    },
    watch: {
      'atendimento.patioDestino' (v) {
        this.changePatioDestino()
      },
      'atendimento.semPlaca' (v) {
        if (v === true) {
          this.atendimento.placa = ''
        } else {
          this.atendimento.firstPlaca = false
          this.atendimento.chassi = ''
        }
      },
      'atendimento.firstPlaca' (v) {
        if (v === true) {
          this.atendimento.semPlaca = true
          this.atendimento.placa = ''
        }
      }
    }
  }
</script>
<style scoped>
  .semplaca{
    justify-content: center;
    display: flex;
  }
  .first-placa{
    justify-content: center;
    display: flex;
    font-size: 12px;
  }
  .chassi{
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// Atendimento.vue?384d465d